import {defineMessages} from 'react-intl';

export const messages = defineMessages({
    PACKAGING_ERROR: {
        id: 'techDoc.storeCheckResultsRootCause.option.packagingError',
        defaultMessage: 'Packaging error'
    },
    CONFORM_PART: {
        id: 'techDoc.storeCheckResultsRootCause.option.conformPart',
        defaultMessage: 'Conform part'
    },
    DLU_OVERDUE: {
        id: 'techDoc.storeCheckResultsRootCause.option.dluOverdue',
        defaultMessage: 'DLU overdue'
    },
    ORDER_ERROR: {
        id: 'techDoc.storeCheckResultsRootCause.option.orderError',
        defaultMessage: 'Order error'
    },
    WRONG_PART_SERVED: {
        id: 'techDoc.storeCheckResultsRootCause.option.wrongPartServed',
        defaultMessage: 'Wrong part served'
    },
    MELTED_REFERENCES: {
        id: 'techDoc.storeCheckResultsRootCause.option.meltedReferences',
        defaultMessage: 'Melted references'
    },
    WRONG_LABELLING: {
        id: 'techDoc.storeCheckResultsRootCause.option.wrongLabelling',
        defaultMessage: 'Wrong labelling'
    },
    DAMAGED_PART: {
        id: 'techDoc.storeCheckResultsRootCause.option.damagedPart',
        defaultMessage: 'Damaged part'
    },
    NOT_CONFORM_PART: {
        id: 'techDoc.storeCheckResultsRootCause.option.notConformPart',
        defaultMessage: 'Not conform part'
    }
});

export default messages;
